// pdf_export - S47.3b / S48.1.
// "PDF" sin libs: canvas -> dataURL -> window.open() con HTML print-friendly
// + window.print() automatico.
// S48.1: acepta `bundle` y lo propaga a renderEtiquetaPng.
import { renderEtiquetaPng } from './png_export';
import { findSize } from '../utils';

function _safeName(s) {
  return String(s || '').replace(/[^A-Za-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '');
}

function _escHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function _suffix(producto, bundle) {
  if (bundle && bundle.code) return '-' + _safeName(bundle.code);
  if (producto && (producto.sku || producto.codigo)) {
    return '-' + _safeName(producto.sku || producto.codigo);
  }
  return '';
}

function _buildHtml(dataUrl, sz, title) {
  const wMm = sz.wMm.toFixed(2);
  const hMm = sz.hMm.toFixed(2);
  const t = _escHtml(title || 'Etiqueta');
  return [
    '<!doctype html>',
    '<html lang="es">',
    '<head>',
    '<meta charset="utf-8">',
    '<title>' + t + '</title>',
    '<style>',
    '@page { size: ' + wMm + 'mm ' + hMm + 'mm; margin: 0; }',
    'html, body { margin: 0; padding: 0; background: #fff; }',
    'body { display: flex; align-items: center; justify-content: center; min-height: 100vh; font-family: sans-serif; color: #111; }',
    '.wrap { width: ' + wMm + 'mm; height: ' + hMm + 'mm; box-sizing: border-box; }',
    '.wrap img { display: block; width: 100%; height: 100%; }',
    '.no-print { position: fixed; top: 12px; right: 12px; }',
    '.no-print button { padding: 8px 14px; font: 500 13px sans-serif; cursor: pointer; }',
    '@media print { .no-print { display: none; } }',
    '</style>',
    '</head>',
    '<body>',
    '<div class="wrap"><img alt="' + t + '" src="' + dataUrl + '" /></div>',
    '<div class="no-print">',
    '<button onclick="window.print()">Imprimir / Guardar PDF</button>',
    '</div>',
    '<script>window.addEventListener("load", function () { setTimeout(function () { window.print(); }, 250); });</script>',
    '</body>',
    '</html>',
  ].join('\n');
}

export function exportEtiquetaPdf(state, producto, bundle) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;
  const dataUrl = renderEtiquetaPng(state, producto, bundle);
  if (!dataUrl) return false;
  const sz = findSize(state && state.sizeId);
  const title = 'etiqueta-' + _safeName((state && state.sizeId) || 'tag') + _suffix(producto, bundle);
  const html = _buildHtml(dataUrl, sz, title);
  const w = window.open('', '_blank');
  if (!w) return false;
  w.document.open();
  w.document.write(html);
  w.document.close();
  return true;
}
